import axios from 'axios'
import store from '../../store' // access to user's access token
import { AuthForAxios, tokenExchange } from '@vigilantapps/ui-library/src/utils/auth-api'

// determine prefix for api
export const ApiVersion = 'v1';

/**
 * send api requests without any authentication headers
 */
export const ajaxNoAuth = axios.create({
  baseURL: `/api/${ApiVersion}`,
  timeout: 20/*secs*/*1000,
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
  }
})

/**
 * send ajax requests with automatic
 */
export const ajaxAuth = new AuthForAxios(
  () => store,
  (a, b, c) => wrapWithErrorFilter(asJson(te(ajaxNoAuth.post(a, b, c)))),
  (a, b, c) => wrapWithErrorFilter(asJson(te(ajaxNoAuth.get(a, b, c)))),
  (a, b, c) => wrapWithErrorFilter(asJson(te(ajaxNoAuth.delete(a, b, c)))),
  (a, b, c) => wrapWithErrorFilter(asJson(te(ajaxNoAuth.put(a, b, c)))),
  (a, b, c) => wrapWithErrorFilter(asJson(te(ajaxNoAuth.head(a, b, c))))
)

export function te (promise) {
  return promise.then(r => tokenExchange(store, r))
}

export function asJson (promise) {
  return promise.then(r => r.data)
}

export function wrapWithErrorFilter (promise) {
  return promise.catch(e => {
    if (e && e.response) {
      if (e.response.status === 401) {
        store.commit('auth/logout') // need to wipe these otherwise next logon will confuse and cycle
        document.location = '/oauth/login'
        return
      }
      if (e.response.data && e.response.data.error) {
        return Promise.reject(new Error(e.response.data.error))
      }
    }
    // TODO: check error in json payload
    return Promise.reject(e)
  });
}